export const roles = (state = []) => state;
